import React, { FC, Fragment } from "react";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

interface Props {
  text: string;
}

export const Linkify: FC<Props> = (props) => {
  const parts = props.text.split(URL_REGEX).map((part, index) => {
    if (part.match(URL_REGEX)) {
      return (
        <a key={index} href={part} rel="noopener noreferrer" target="_blank">
          {part}
        </a>
      );
    } else {
      return part;
    }
  });

  return <Fragment>{parts}</Fragment>;
};

export default Linkify;
